<template>
  <div>
    <div v-if="showadd">
        <button type="button" @click="showTagParameters">Create Tag</button>
    </div>  
    <div v-if="showCancelButton">
        <button type="button" @click="hideTagParameters">Cancel</button>
    </div>  
    <div class="row" v-if="showTagAddParameters">
        <div class="col-md-12" >
        <b>Select Tag Category</b>
        <select class="form-control"  name="ticketTagCategory" style="overflow:scroll;" v-model="idTicketTagCategory" @change="handleChange">
        <option disabled selected value="-1"> -- Select a tag Category to add ticket tag-- </option>
        <option :value="tc.idTicketTagCategory" v-for="tc in ticketTagCategory" v-bind:key="tc.idTicketTagCategory">{{tc.Name}}</option>
        </select><br>
        <b v-if="ticketTagSubCategory_visible">Select Tag SubCategory</b>
        <select v-if="ticketTagSubCategory_visible" class="form-control"  style="overflow:scroll;" v-model="idTicketTagSubCategory" @change="handleChangeSub">
        <option disabled selected value="-1"> -- Select a tag sub Category -- </option>
        <option :value="tsc.idTicketTagSubCategory" v-for="tsc in filteredTagSubCategories" v-bind:key="tsc.idTicketTagSubCategory">{{tsc.Name}}</option>
        </select><br>
        
        
        
        <div v-if="tagInfo_visible">
        <b>Select applicable User</b>
        <select v-if="ticketTagSubCategory_visible" class="form-control"  style="overflow:scroll;" v-model="selectedUser" >
        <!--<option disabled selected value="-1"> Select a tag sub Category </option>-->
           <option disabled value="-1"> -- Select a user -- </option>
            <option :value="user.idEmployee" v-for="user in users" v-bind:key="user.idEmployee" >{{user.employee}}</option>
        </select><br>
        <b>Select applicable Date</b>
        <datetime v-model="tagDate"></datetime><br>
        <div v-if="tagHasData"><b>Set tag value </b><input  type="text" name="tagInfo" class="form-control" v-model="tagInfo"/><br></div>
            
            <button type="button" @click="AddTag">Create Tag</button>
        </div><br>
        <div v-for="(tag, index)  in addedTags" v-bind:key="tag.idTicketTag" >
            
            <div  style="border: 1px solid black;border-radius: 5px; padding: 5px;color:white;width: max-content;display: inline-block;"  v-bind:style="{ 'background-color' : tag.category.TagColour }">{{tag.category.Name}}</div>
            <div  style="border: 1px solid black;border-radius: 5px; padding: 5px;color:white;width: max-content;display: inline-block;"  v-bind:style="{ 'background-color' : tag.subcategory.TagColour }">{{tag.subcategory.Name}}</div>
            
            <div  v-if="tag.subcategory.hasData" style="border: 1px solid black;border-radius: 5px; padding: 5px;color:white;width: max-content;display: inline-block;"  v-bind:style="{ 'background-color' : tag.subcategory.TagColour }">{{tag.value}}</div>
            <div  style="border: 1px solid black;border-radius: 5px; padding: 5px;color:white;width: max-content;display: inline-block;"  v-bind:style="{ 'background-color' : tag.subcategory.TagColour }">{{tag.employeeName}}</div>
            <div  style="border: 1px solid black;border-radius: 5px; padding: 5px;color:white;width: max-content;display: inline-block;"  v-bind:style="{ 'background-color' : tag.subcategory.TagColour }">{{tag.tagDate}}</div>
            
            <button type="button" @click="RemoveTag(index)" style="border-radius: 5px;padding: 5px" >Remove Tag</button><br><br>
            <input type="hidden" name="tag_category" :value="tag.category.idTicketTagCategory"/>
            <input type="hidden" name="tag_subcategory" :value="tag.subcategory.idTicketTagSubCategory"/>
            <input type="hidden" name="tag_subcategoryType" :value="tag.subcategory.Type"/>
            <input type="hidden" name="tag_value" :value="tag.value"/>
            <input type="hidden" name="tag_employee" :value="tag.employee"/>
            <input type="hidden" name="tag_date" :value="tag.tagDate"/>
            <input type="hidden" name="description" :value="tag.description"/>
            <input type="hidden" name="hasData" :value="tag.subcategory.hasData"/>
           
            
        </div>
        <br>
        <div v-if="finalAddTagsButton">
          <button type="button" @click="addTagsSystems">Save created Tag/Tags</button>
        </div>
         <div v-if="loadingGifButton">
             <img  src="img/loading.gif" class="center-block" alt="Loading ...">
        </div>
        </div>     
    </div> 
  </div>
</template>



<script type="text/javascript">
//const ActionButton = require('./ActionButton.vue');

import moment from 'moment';
 import axios from 'axios';

//module.exports = {
  export default {
   props: ['ticketid','idticketcomment','showadd'],
  data: () => ({
    
    // testProp :  this.test,
    showTagAddParameters: false,
    
    showCancelButton : false,
    finalAddTagsButton : false,
    loadingGifButton    : false,
    testName : "test no change",
    idTicketTagCategory : -1,
    selectedTagCategory : -1,
    idTicketTagSubCategory : -1,
    selectedUser : -1,
    selectedTagSubCategory : -1,
    tagInfo : "",
    ticketTagCategory : null,
    ticketTagSubCategory_visible : false,
    tagHasData : false,
    ticketTagSubCategory : null,
    ticketTagType : null,
    ticketTagType_visible : false,
    addedTags : [],
    users : null,
    tagInfo_visible : false,
    
    
    tagDate : null
    
  }),
  methods: {
      handleChange : function() {
          console.log(this.idTicketTagCategory);
          console.log(this);
          console.log(this.filteredTagSubCategories);
          var mainObject = this; 

          mainObject.ticketTagSubCategory_visible = true; 
          mainObject.idTicketTagSubCategory = -1;
          mainObject.selectedTagCategory = mainObject.ticketTagCategory.filter( function(item){
            return ( item.idTicketTagCategory == mainObject.idTicketTagCategory );
          });
          /*try{
            mainObject.idTicketTagSubCategory = this.filteredTagSubCategories[0].idTicketTagSubCategory; 
          }
          catch(err)
          {

          }*/
      },
      handleChangeSub : function() {
          //console.log("Subcategory selected");
          //console.log(this.ticketTag.tagInfo_visible);
          var mainObject = this; 
          mainObject.tagInfo_visible = true;
          mainObject.selectedTagSubCategory = mainObject.ticketTagSubCategory.filter( function(item){
            return ( item.idTicketTagSubCategory == mainObject.idTicketTagSubCategory );
          });
          console.log("testing code");
          console.log(mainObject);

          if (mainObject.selectedTagSubCategory[0].hasData)
                 mainObject.tagHasData = true; 
               else
                 mainObject.tagHasData = false; 
          console.log(mainObject);

          
          

      },
      handleChangeTagType : function() {
          console.log("handleChangeTagType selected");
      } ,
      // Add all the tags to teh databse through the NODE JS API
      addTagsSystems : function() {
        console.log("Add all tags to the database");
        console.log(this.addedTags);
        var mainObject = this;
        mainObject.finalAddTagsButton = false;
        mainObject.loadingGifButton = true;
        axios.post(localStorage.getItem('ticketCopURL') +'/createTicketTag', {
              //params: {
                  tagsToAdd : this.addedTags,
                  employee : localStorage.getItem('employee') },{
                  headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
              //}
            })
            .then(function (response) {
              console.log(response);
              //bootbox.alert("All Tags were added. Refresh page to see them", function () { });

               // reset view
              mainObject.showTagAddParameters = false;
              mainObject.showadd = true;
              mainObject.showCancelButton = false;
              
              mainObject.addedTags = [];
              mainObject.$parent.refresh_data();


            })
            .catch(function (error) {
              console.log(error);
            })
            .then(function () {
              // always executed
              console.log("Added Tags to the system");
              let timerInterval
                    mainObject.$swal({
                    //title: 'Auto close alert!',
                    html: 'New tag/tags was added.',
                    timer: 2000,
                    onBeforeOpen: () => {
                        mainObject.$swal.showLoading()
                        timerInterval = setInterval(() => {
                        mainObject.$swal.getContent().querySelector('strong')
                            
                        }, 100)
                    },
                    onClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                    if (
                        // Read more about handling dismissals
                        result.dismiss === mainObject.$swal.DismissReason.timer
                    ) {
                        console.log("");
                        
                    }
                    })  
               mainObject.loadingGifButton = false;
        });
      },
      
      AddTag : function ()
      {

        console.log(this.tagInfo.length);
        var mainObject = this;
        this.finalAddTagsButton = true;
        // case where there is no tag data to eb added
        if ( !mainObject.selectedTagSubCategory[0].hasData )
        {
            console.log("Create tag No data");
            let obj = new Object;
            obj.category = mainObject.selectedTagCategory[0];
            obj.subcategory = mainObject.selectedTagSubCategory[0];
            obj.value = mainObject.tagInfo;
            obj.employee = mainObject.selectedUser;
            obj.employeeName = mainObject.users.filter( function(item){
              return ( item.idEmployee == mainObject.selectedUser );
            })[0].employee;
            obj.tagDate = moment(mainObject.tagDate).format("YYYY-MM-DD");
            obj.description = obj.employeeName+" | "+ mainObject.selectedTagSubCategory[0].Name+" | "+obj.value;
            obj.idTicket = mainObject.ticketid;
            obj.idticketcomment = mainObject.idticketcomment;
            mainObject.addedTags.push(obj);
            console.log(mainObject.addedTags);

        }
        else
        {
          if ( mainObject.tagInfo.length < 1)
            //bootbox.alert("Please insert value for tag", function () { });
            mainObject.$swal('Please set tag value.')
          else
          {
            if ( mainObject.idTicketTagSubCategory == -1 )
            {
              //bootbox.alert("Please select a tag sub category.", function () { });
              mainObject.$swal('Please select a tag sub category.')
              
          

            }
            else
            {
              console.log(mainObject.selectedTagSubCategory[0].Type);
              var valid = false;
              switch ( mainObject.selectedTagSubCategory[0].Type )
              {
                case "INTEGER" : if ( !isNaN(mainObject.tagInfo)  )
                          {
                            if (  mainObject.tagInfo % 1 === 0 ) 
                              valid =  true; 
                            else
                              //bootbox.alert("Tag value must be an integer number", function () { });
                              mainObject.$swal('Tag value must be an integer number.')
                            break;
                          }
                          else
                          {
                          
                              //bootbox.alert("Tag value must be an integer number", function () { });
                              mainObject.$swal('Tag value must be an integer number.')
                              break;
                          }
                case "FLOAT" : if ( !isNaN(mainObject.tagInfo) )
                          { 
                            valid =  true; 
                            break;
                          }
                          else
                          {
                          
                              //bootbox.alert("Tag value must be a number", function () { });
                              mainObject.$swal('Tag value must be a number.')
                              break;
                          }
                case "STRING" : if ( typeof mainObject.tagInfo === 'string'  )
                          { 
                            valid =  true; 
                            break;
                          }
                          else
                          {
                          
                              //bootbox.alert("Tag value must be a string", function () { });
                              mainObject.$swal('Tag value must be a string.')
                              break;
                          }
                case "BOOLEAN" : if ( typeof mainObject.tagInfo === 'boolean' )
                          { 
                            valid =  true; 
                            break;
                          }
                          else
                          {
                          
                              //bootbox.alert("Tag value must be a boolean value, ie true or false", function () { });
                              mainObject.$swal('Tag value must be a boolean value, ie true or false.')
                              break;
                          }
                case "DATE TIME" : 
                          var date = moment(mainObject.tagInfo);

                          if ( date.isValid())
                          { 
                            valid =  true; 
                            break;
                          }
                          else
                          {
                          
                              //bootbox.alert("Tag value must be a date format YYYY-MM-DD HH:MM", function () { });
                              mainObject.$swal('Tag value must be a date format YYYY-MM-DD HH:MM.')
                              break;
                          }
                default :  break;
                
              }
              if ( mainObject.selectedUser < 1 ) 
              {
                  valid=false;
                  mainObject.$swal('Please select a user.')
              }
              if ( valid ) 
                {
                  // create a new Tag and add it to list 
                  console.log("Create tag");
                  let obj = new Object;
                  obj.category = mainObject.selectedTagCategory[0];
                  obj.subcategory = mainObject.selectedTagSubCategory[0];
                  obj.value = mainObject.tagInfo;
                  obj.employee = mainObject.selectedUser;
                  obj.employeeName = mainObject.users.filter( function(item){
                    return ( item.idEmployee == mainObject.selectedUser );
                  })[0].employee;
                  obj.tagDate = moment(mainObject.tagDate).format("YYYY-MM-DD");
                  obj.description = obj.employeeName+" | "+ mainObject.selectedTagSubCategory[0].Name+" | "+obj.value;
                  obj.idTicket = mainObject.ticketid;
                  obj.idticketcomment = mainObject.idticketcomment;
                  mainObject.addedTags.push(obj);
                  console.log(mainObject.addedTags);
                }
            }

          }
        }

      },
      showTagParameters : function ()
      {
            this.showTagAddParameters = true;
            this.showadd =  false;
            this.showCancelButton = true;

      },
      hideTagParameters : function ()
      {
            this.showTagAddParameters = false;
            this.showCancelButton = false;

            this.showadd =  true;

      },
      
      RemoveTag : function (index)
      {
        //console.log("Remove Tag"); 
        //console.log("Index :"+index);
        this.addedTags.splice(index,1);
        if ( this.addedTags.length == 0 )
        {
           this.finalAddTagsButton = false;
        }
      }
  },
  computed: {
    filteredTagSubCategories: function () {
      var self = this
      return self.ticketTagSubCategory.filter(function (cat) {
        return cat.idTicketTagCategory == self.idTicketTagCategory
      })
    }
  },
  created: function () {
    // `this` points to the vm instance
    //console.log("Create Ticket tag was created")
    // console.log(this.testProp);
    //var ticket = this.ticket;
    var mainObject = this;
    mainObject.tagDate = moment().toISOString()
   // console.log("Set date to "+mainObject.tagDate);
    axios.get(localStorage.getItem('ticketCopURL') +'/getTicketTagCategory', {
          params: {
              
           
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          //console.log(response);
          if ( response.data != -1 )
          mainObject.ticketTagCategory = response.data;
          mainObject.seen = true;
          mainObject.testName = response.data[0].Name;
            //console.log(mainObject);

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          //console.log("Made request axios ticket tag category");
    });
     axios.get(localStorage.getItem('ticketCopURL') +'/getTicketTagSubCategories', {
          params: {

          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          //console.log(response);
          if ( response.data != -1 )
          mainObject.ticketTagSubCategory = response.data;
          
          //mainObject.ticketTagSubCategory_visible = true;

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          //console.log("Made request axios ticket tag sub category");
    }); 
    axios.get(localStorage.getItem('ticketCopURL') +'/getUsers', {
          params: {

          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          //console.log(response);
          if ( response.data != "Error" )
          mainObject.users = response.data.users;
          //mainObject.selectedUser = response.data.current_user;
          //mainObject.ticketTagSubCategory_visible = true;

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          //console.log("Made request to get users");
    }); 
    
  }
  
  /*,
  components: {
    ActionButton
  }*/
};
</script>